import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { UPDATE_DATA_REQUEST_ASYNC } from 'containers/Mailboxes/Management/VipDiscovery/constants'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'
import { addToast } from 'containers/Toasts/actions'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import {
  fetchDataError,
  fetchDataSuccess,
  updateVipUsersForScanbackError,
  updateVipUsersForScanbackSuccess,
} from './actions'
import { DATA_REQUEST_ASYNC, UPDATE_VIP_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DATA_REQUEST_ASYNC.INITIATE,
      UPDATE_VIP_REQUEST_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return (
          matchURL(URL_CONST.incidents.scanbackOverview) || matchURL(URL_CONST.incidents.scanback)
        )
      return true
    }),
    mergeMap(() =>
      api.resolutionCenter.getScanbackData(selectCompanyFilter(state$.value)?.value).pipe(
        map((response) => fetchDataSuccess(response)),
        catchError((error) => of(epicsErrorHandler(fetchDataError, error, [400]))),
        takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

const updateVipDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_VIP_REQUEST_ASYNC.INITIATE),
    mergeMap((action) =>
      api.mailboxes
        .updateVipUsersData(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload.data?.map((e) => [e.profileId, e.title, true])
        )
        .pipe(
          mergeMap((response) => {
            if (response.response.vipProfilesLength) {
              return of(
                addToast({
                  message:
                    "'vip_impersonation' tags were successfully added to the selected profiles",
                }),
                updateVipUsersForScanbackSuccess(response)
              )
            } else {
              return of(updateVipUsersForScanbackError(response))
            }
          }),
          catchError((error) => of(epicsErrorHandler(updateVipUsersForScanbackError, error))),
          takeUntil(action$.pipe(ofType(UPDATE_DATA_REQUEST_ASYNC.CANCEL)))
        )
    )
  )
export default combineEpics(fetchDataEpic, updateVipDataEpic)
